'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');

const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:exCoPlayer');

const EXCOPLAYER_SCRIPT = 'https://player.ex.co/player/';

getDependencyClass('phoenix-page').then((pageClass) => {
    class ExCoPlayer extends pageClass.PhoenixElement {
        constructor() {
            super();
            this.exsConfig = {};
            this.index = 0;
        }

        connectedCallback() {
            if (!window.GdprStatus) {
                throw new Error('window.GdprStatus is required');
            }

            this.canRender().then((canRender) => {
                if (canRender) {
                    this.addListeners();
                    this.render();
                } else {
                    this.setAttribute('aria-hidden', true);
                    this.style.display = 'none';
                }
            });
        }

        render() {
            const { playerId, exsConfig } = this.dataset;
            const baseModel = window.phxPageTarget.config.global.baseModel;
            try {
                this.exsConfig = JSON.parse(exsConfig);
            } catch {}

            const self = this;

            var aq = window.phxAdvertisingQueue || (window.phxAdvertisingQueue = []);
            aq.push(function () {
                this.adAuctionPromise.then((auction) => {
                    // Get targeting values directly from Google Ads
                    const getTargetingValue = (key) => {
                        try {
                            if (window.googletag && window.googletag.pubads) {
                                const values = window.googletag.pubads().getTargeting(key);
                                if (Array.isArray(values)) {
                                    return values.join(',');
                                }
                                return values;
                            }
                        } catch (e) {
                            // Targeting might not be set yet
                        }
                        return undefined;
                    };

                    self.exsConfig = {
                        ...self.exsConfig,
                        customParams: {
                            ...self.exsConfig.customParams,
                            abs: getTargetingValue('abs'),
                            atsd: getTargetingValue('atsd'),
                            author: baseModel.author,
                            bmb: getTargetingValue('bmb'),
                            bsc: getTargetingValue('bsc'),
                            correlator: window.mavenCorrelator,
                            direct: '' + baseModel.directOnly,
                            terms: baseModel.terms.join(','),
                            pagetype: baseModel.pageType,
                            path: baseModel.path,
                            pod: auction.keyValues.pod,
                            vnd_prx_segments: getTargetingValue('vnd_prx_segments'),
                            prmtvctx: getTargetingValue('prmtvctx'),
                        },
                        macros: {
                            gpid: self.createGpid('preroll', 0),
                        },
                    };

                    self.playerDiv = document.createElement('div');
                    self.playerDiv.setAttribute('id', playerId);
                    self.playerDiv.setAttribute('data-exs-config', JSON.stringify(self.exsConfig));
                    self.appendChild(self.playerDiv);

                    pageClass.util.addScriptResourceOnce(`${EXCOPLAYER_SCRIPT}${playerId}`);
                });
            });
        }

        createGpid(zone, index) {
            const path = window.phxPageTarget.config.global.baseModel.path;
            const firstLevelPath = path === '/' ? path : `/${path.split('/')[1]}/`;
            return `/88059007${firstLevelPath}video/${zone}-${index}`;
        }

        addListeners() {
            this.handleMessageHandler = this.handleMessage.bind(this);
            // EX.CO's video player sends all player events as message events.
            window.addEventListener('message', this.handleMessageHandler);
        }

        handleMessage({ data = {} }) {
            const { type, name, metadata = {} } = data;
            if (type === 'exco-event' && name === 'playlist-index-changed') {
                this.index++;
                this.exsConfig.macros.gpid = this.createGpid('preroll', this.index);
                this.playerDiv.setAttribute('data-exs-config', JSON.stringify(this.exsConfig));
            }
            if (type === 'exco-event' && name === 'player-playing') {
                window.googleAnalytics?.sendEvent('video', 'exco-player-load', metadata.playerId, 1, {
                    nonInteraction: 1,
                });
            }
        }

        disconnectedCallback() {
            window.removeEventListener('message', this.handleMessageHandler);
        }
    }
    window.customElements.define('phoenix-exco-player', ExCoPlayer);
    measure.end();
});
